import React from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Target,
  Users,
  Folder,
  PersonStanding,
  Signature,
  Laptop,
  Vault,
  TreePalm,
  Mails,
  IdCardLanyard,
} from "lucide-react";

const Sidebar = ({
  currentEmployeeId,
  isHRManager,
  managerAccess,
  isPreviewUser,
}) => {
  const location = useLocation();
  const sharepointUrl = process.env.REACT_APP_SHAREPOINT_URL;

  const sidebarItems = [
    { icon: Target, path: "/leads", label: "Leads" },
    { icon: Users, path: "/clients", label: "Clients" },
    { icon: Folder, href: sharepointUrl, label: "SharePoint" },
    ...(isPreviewUser || isHRManager
      ? [
          {
            icon: PersonStanding,
            path: "/human_resources",
            label: "Human Resources",
          },
        ]
      : []),
    {
      icon: IdCardLanyard,
      path: currentEmployeeId ? `/employee/${currentEmployeeId}` : null,
      state: { from: "/" },
      label: "My Profile",
    },
    ...(managerAccess
      ? [{ icon: Signature, path: "/contracts", label: "Contracts" }]
      : []),
    { icon: Laptop, path: "/equipment", label: "Equipment" },
    { icon: Vault, path: "/reimbursements", label: "Reimbursements" },
    ...(isPreviewUser || managerAccess
      ? [{ icon: TreePalm, path: "/vacations", label: "Vacations" }]
      : []),
    { icon: Mails, path: "/mail_log", label: "Mail Log" },
  ];

  return (
    <div className="canopy-sidebar">
      {/* Logo */}
      <div className="canopy-sidebar-icon">
        <Link to="/">
          <div>
            <img src="/Logo.gif" alt="Greenlight Financial" />
          </div>
        </Link>
      </div>

      {/* Navigation Items */}
      {sidebarItems.map((item, index) => {
        const Icon = item.icon;
        const isInternal = !!item.path;
        if (!isInternal && !item.href) return null;
        const isActive = isInternal && location.pathname === item.path;

        if (isInternal) {
          return (
            <Link
              to={item.path}
              state={item.state}
              key={index}
              className={`canopy-sidebar-icon ${isActive ? "active" : ""}`}
              title={item.label}
            >
              <Icon className="w-5 h-5" />
            </Link>
          );
        }

        return (
          <a
            key={item.label}
            href={item.href || "#"}
            target="_blank"
            rel="noopener noreferrer"
            className="canopy-sidebar-icon"
            title={item.label}
            onClick={(e) => {
              if (!item.href) e.preventDefault();
            }}
          >
            <Icon className="w-5 h-5" />
          </a>
        );
      })}
    </div>
  );
};

export default Sidebar;
